import { APPLICATION_ENVIRONMENT } from '~~/constants/env';
import { ORDER_HISTORY_MOCK } from '~~/constants/localStorage';
import isStringTrue from '~~/helpers/dataStructure/isStringTrue';
import { Logger } from '~~/helpers/logger';
import { StringBoolean } from '~~/types/StringBoolean';

export const useOrderHistoryMock = () => {

  const { public: publicConfig } = useRuntimeConfig();

  const isAvailable = publicConfig.ENABLE_ORDER_HISTORY_MOCK === true
    && publicConfig.applicationEnvironment !== APPLICATION_ENVIRONMENT.PRODUCTION;

  const isEnabled = useState<boolean>('orderHistoryMockEnabled', () => false);

  const isMocking = computed(() => isAvailable && isEnabled.value);

  const readStoredFlag = (): boolean => {

    try {

      return isStringTrue(localStorage.getItem(ORDER_HISTORY_MOCK));

    } catch (error) {

      Logger.error('Failed to read the order history mock flag from localStorage:', error);

      return false;

    }

  };

  const writeStoredFlag = (value: boolean) => {

    try {

      if (value) {

        localStorage.setItem(ORDER_HISTORY_MOCK, StringBoolean.true);

        return;

      }

      localStorage.removeItem(ORDER_HISTORY_MOCK);

    } catch (error) {

      Logger.error('Failed to save the order history mock flag to localStorage:', error);

    }

  };

  const syncWithLocalStorage = () => {

    if (!import.meta.client || !isAvailable) {

      return;

    }

    isEnabled.value = readStoredFlag();

  };

  const toggle = () => {

    if (!isAvailable) {

      return;

    }

    isEnabled.value = !isEnabled.value;
    writeStoredFlag(isEnabled.value);

  };

  return {
    isAvailable,
    isEnabled,
    isMocking,
    syncWithLocalStorage,
    toggle,
  };

};
